
import state from './moduleBoardsState.js'
import mutations from './moduleBoardsMutations.js'
import actions from './moduleBoardsActions.js'
import getters from './moduleBoardsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}